import styled from "styled-components";

export const Subtitle = styled.h5`
    font-weight: 400;
    margin-top: 0.2rem;
    margin-bottom: 1rem;
`;